import React from "react";
import { useTranslation } from "react-i18next";
import PopupTrigger from "../../../../common/PopupTrigger";
import Popup from "../../../../common/Popup";

const NotEnteredAnswerPopup = ( props ) => {

  const { t } = useTranslation();

  return (
    <PopupTrigger onClose={ props.onHide }>
      <Popup onConfirm={ props.onConfirm }>
        <p className="lc-alert_txt m-fw-normal" dangerouslySetInnerHTML={ { __html : t( 'LC_05_20.msg011' ) } } />
      </Popup>
    </PopupTrigger>
  );

};

export default NotEnteredAnswerPopup;
